import React, { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAdjustModel } from "./adjustModel";
import { IAccountAdjustDetail } from "../../../../AccountTypes";


const columns: ColumnsType<IAccountAdjustDetail> = [
    {
        align: "center",
        title: '分支',
        dataIndex: 'branch',
    },
    // {
    //     title: '编码',
    //     dataIndex: 'code',
    // },
    // {
    //     title: '账户编码',
    //     dataIndex: 'accountCode',
    // },
    {
        align: "center",
        title: '账户名称',
        dataIndex: 'accountName',
    },
    {
        align: "center",
        title: '授信类型',
        dataIndex: 'creditFlag',
        render: (v) => v === 1 ? '记账' : v === 0 ? '现结' : ''
    },
    {
        align: "center",
        title: '从属机构',
        dataIndex: 'orgName',
    },
    {
        align: "center",
        title: '账户实体',
        dataIndex: 'beName',
    },
    {
        align: "center",
        title: '授信额度',
        dataIndex: 'creditAmount',
    },
    {
        align: "center",
        title: '调整额度',
        dataIndex: 'adjustAmount',
    },
    {
        align: "center",
        title: '业务员',
        dataIndex: 'createUser',
    },
    {
        align: "center",
        title: '调额日期',
        dataIndex: 'createTime',
    },
    // {
    //     title: '客户类型',
    //     dataIndex: 'partnerTypeCode',
    // },
    // {
    //     title: '客户编码',
    //     dataIndex: 'partnerCode',
    // },
    // {
    //     title: '客户名称',
    //     dataIndex: 'partnerName',
    // },

    {
        align: "center",
        title: '审核状态',
        dataIndex: 'status',
        render: (v) =>
            v === 0 ? '初始'
                : v === 1 ? '审核中'
                    : v === 2 ? '审核通过(已调整)'
                        : v === 8 ? '审核驳回'
                            : v === 9 ? '失败'
                                : ''
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },
    // {
    //     title: '操作',
    //     dataIndex: 'state',
    //     render: (text, record) =>
    //     (
    //         <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked checked={text === 0} />
    //     )
    // },

];

export function AdjustDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useAdjustModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountAdjustDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
